import { Breakpoint } from '@/features/breakpoint';
import { useFloatBetslip } from './use-float-betslip';
import { useBreakpoint } from '@/features/breakpoint/contexts';

export const useAsideBetslip = () => {
	const { breakpoint } = useBreakpoint();
	const { activeFloatBetSlip } = useFloatBetslip();
	const activeAsideBetSlip = !activeFloatBetSlip && (Breakpoint.lg < breakpoint);
	return {
		activeAsideBetSlip
	}
}